module.exports = __webpack_public_path__ + "static/media/personDark.ad9fd05a.svg";